var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVfd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: "1em",
    viewBox: "0 0 143 32",
    fill: "none",
    className: "h-8 w-[143px] md:h-full",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#LogoLight_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5 15.96c0-5.07 3.636-9.126 8.485-9.126 2.175 0 4.136.858 5.598 2.262l-1.176 1.482c-1.248-1.17-2.674-1.755-4.279-1.755-3.78 0-6.525 3.198-6.525 7.137 0 3.94 2.746 7.176 6.418 7.176 1.89 0 3.601-.819 4.778-2.184l1.248 1.521c-1.498 1.638-3.601 2.691-6.026 2.691-4.885 0-8.521-4.056-8.521-9.204ZM53.186 16c0-5.149 3.423-9.166 7.88-9.166 4.314 0 7.665 4.017 7.665 9.126 0 .273-.035.507-.035.585H55.29c.356 4.446 3.672 6.591 6.06 6.591 2.069 0 3.566-.624 5.064-2.262l1.176 1.404c-1.319 1.716-3.922 2.847-6.24 2.847-4.527.04-8.164-3.822-8.164-9.126Zm13.477-1.17c0-3.004-2.282-6.007-5.597-6.007-3.316 0-5.776 3.471-5.776 6.006h11.373ZM88.413 7.107h1.925v17.785h-1.925V7.107ZM100.178 7.03h1.818l7.63 17.862h-2.032l-1.498-3.471h-9.983l-1.498 3.47h-2.067l7.63-17.862Zm5.169 12.597-2.995-6.904c-.534-1.287-1.176-3.003-1.283-3.198-.107.234-.713 1.911-1.284 3.198l-2.995 6.903h8.557ZM84.099 7.068h2.068l-7.63 17.863h-1.819l-7.63-17.863h2.033l5.205 12.168c.535 1.288 1.177 3.004 1.284 3.199.107-.234.713-1.911 1.283-3.198L84.1 7.067ZM111.872 7.107h1.996l8.094 11.545c.82 1.209 1.747 2.886 1.747 2.886V7.108h1.997v17.784h-2.068l-7.951-11.271c-.963-1.405-1.819-3.082-1.819-3.082v14.353h-1.996V7.107ZM134.264 9.018h-6.061v-1.91h14.083v1.91h-6.025v15.874h-1.997V9.018Z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.274.008 16.9 32.02 16.9-32.02H.274Zm22.57 4.602-11.588 7.02-3.673-7.02h15.26Zm-5.67 18.135-3.78-7.137 11.41-7.332-7.63 14.47Z",
    fill: "#248FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "LogoLight_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h142.546v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVfd);
export default __webpack_public_path__ + "static/media/vfd.d275121bc0df6734d4d964d38ef5652c.svg";
export { ForwardRef as ReactComponent };